export default __webpack_public_path__ + "static/media/undraw_winners_ao2o 2.d76bfdf8.svg";